import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { GeneralService } from '../../../../services/general/general.service';

@Component({
  selector: 'app-create-group-classes',
  templateUrl: './create-group-classes.component.html',
  styleUrls: ['./create-group-classes.component.scss']
})
export class CreateGroupClassesComponent implements OnInit {
  
  public form: FormGroup;
  public teacher_subjects: any;
  public user_id:any = "";
  public teacher_info: any;
  public teacher_lessons: any;
  public teacher_langs: any;
  public lessons: any;
  public students: any;
  public showManualStudents: any;
  public showAddStudent: boolean = true;
  public loadingQuery: boolean = false;

  constructor(
    public general: GeneralService,
    private formBuilder: FormBuilder,
  ) {

   this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      description: ['', [Validators.required]],
      date: ['', [Validators.required]],
      hour: ['', [Validators.required]],
      duration: ['', [Validators.required]],
      price: ['', [Validators.required, Validators.min(5)]],
      language_id:['', [Validators.required]],
      visibility:['', [Validators.required]],
      lesson_id:['', [Validators.required]],
      lesson_level_id:[''],
      status:[1, [Validators.required]],
      studentInvitation:['', [Validators.required]],
      students: this.formBuilder.array([]),
      conditions: [false, [Validators.requiredTrue]],
      timezone: [this.general.getCurrentTimezone(), [Validators.required]],
    });

   }

  async ngOnInit() {


    

    await this.getTeacherInfo();

    this.form.controls['studentInvitation'].valueChanges.subscribe(value => {
      value=="2" ? this.showManualStudents = true : this.showManualStudents = false;
    });

  }

  async getTeacherInfo() {

    try {
      // cargar todas las clases para coger nombres
      const lessons =  await this.general.httpGet('study-lessons');
      this.lessons = lessons.data.data;
      
      // cargar datos del profesor actual y asignar en variables independientes
      const requests_teacher_info = await this.general.httpPost('teacher-info', this.user_id);
      this.teacher_info = requests_teacher_info.message;
      this.teacher_langs = this.teacher_info.user.Languages;
      this.teacher_lessons = this.teacher_info.lessons;

    } catch (error: any) {
      this.general.showDanger(error.message);
    }

  }

  get studentsFormArray(): any {
    return this.form.get('students') as FormArray;
  }

  onChangeLesson(event: any) {
    this.form.get("lesson_id")?.patchValue(event.value.id);
    this.form.get("lesson_level_id")?.patchValue(event.value.pivot.level_id);
  }
  
  addStudent(): void {
    this.studentsFormArray.push(
      this.formBuilder.group(
        {
          id: [null],
          typeStudent: [''],
          name: [''],
          email: [''],
        }
      )
    );
    this.checkShowAddStudent();
  }
  
  checkShowAddStudent(){
    //máximo permitimos añadir 4 alumnos
    this.studentsFormArray.controls.length <= 3 ? this.showAddStudent = true : this.showAddStudent = false;
  }

  removeStudent(index: any): void {
    this.studentsFormArray.removeAt(index);
    this.checkShowAddStudent();
  }

  onChangeTypeStudent(event: any, customStudent: any) {
    customStudent.patchValue({
      id: null,
      name: "",
      email: "",
    });
  }

  onChangeStudent(event: any, customStudent: any) {
    customStudent.patchValue({
      id: event.value.id,
      name: event.value.fullName,
      email: event.value.email,
    });
  }

  get validateform() {
    
    if(this.form.valid) {

      //check: si ha elegido seleccionar alumnos manualmente, controlar que al menos haya añadido 1
      if(this.form.value.studentInvitation == "2") {

        if(this.form.value.students.length >= 1) {

          let flagError = false;

          //comprobamos que haya rellenado los campos de los alumnos añadidos.
          this.form.value.students.forEach((student: any) => {
            if (student.typeStudent == "myStudents") {
              if(!student.id || !student.name || !student.email){
                flagError = true;
              }
            }else if (student.typeStudent == "newStudent") {
              if(!student.name || !student.email){
                flagError = true;
              }
            }else{
              flagError = true;
            }
          });

          if(flagError) {
            return false;
          }else {
            return true;
          }

        }else {
          return false;
        }
      
      }else {
        return true;
      }
    } else return false;
  }

  async sendForm() {

    try {
      this.loadingQuery = true;
      const response = await this.general.httpPost('groupal-class-store', this.form.value);
      if(response) {
        this.general.sleep(200);
        this.general.showSuccess('data-saved-successfully');
        this.general.navigate(`/teacher/group-classes`);
      }

    } catch (error) {
      this.general.showErrorForm(error);
      console.log(error);
    } finally{
      this.loadingQuery = false;
    }
  }

  cancel(){
    this.general.navigate(`/teacher/group-classes`);
  }

}